/* @flow */

import { errorColor } from '@e180/ui/lib/token/color';
import { gutter } from 'src/shared/app/base/style/token/grid';
import { navBarMobileHeight } from 'src/shared/app/base/component/template/style/template.style';

export default {
  root: {
    margin: [0, gutter],
    paddingBottom: navBarMobileHeight,
  },
  radioSection: {
    position: 'relative',
  },
  heading: {
    display: 'block',

    margin: '48px 0 12px',
  },
  mandatory: {
    color: errorColor,
  },
  instructions: {
    marginTop: 40,
  },
  sendButton: {
    display: 'flex',
    justifyContent: 'center',
  },
  error: {
    position: 'absolute',
    top: 'calc(100% + 12px)',
    left: '0',
  },
};
